import { IYantrasColumn } from "../entities/yantras/yantraCards";
import { IYantra } from "../entities/yantras/yantras";

export const rowsConfiguration = [
  { name: "Red", color: "#FF0000" },
  { name: "Blue", color: "#0000FF" },
  { name: "Green", color: "#00FF00" },
  { name: "Yellow", color: "#FFFF00" },
  { name: "Magenta", color: "#FF00FF" },
  { name: "Cyan", color: "#00FFFF" },
  { name: "Orange", color: "#FF8800" },
  { name: "Indigo", color: "#8844FF" },
  { name: "DarkGreen", color: "#008800" },
  { name: "DarkRed", color: "#880000" },
];

export const getYantrasRows = (
  yantras: IYantra[],
  rows: number,
  cols: number
): IYantrasColumn[] => {
  if (yantras.length !== rows * cols) return [];

  return Array.from({ length: rows }, (_, rowIndex) => ({
    borderColor: rowsConfiguration[rowIndex % rowsConfiguration.length].color,
    name: rowsConfiguration[rowIndex % rowsConfiguration.length].name,
    cards: yantras
      .slice(rowIndex * cols, (rowIndex + 1) * cols)
      .map((yantra, index) => ({
        id: String(rowIndex * cols + index),
        name: yantra.name,
        image: yantra.image,
      })),
  }));
};
